export const FILTERED_INPUT_DATA_REQUEST = "FILTERED_INPUT_DATA_REQUEST";
export const FILTERED_INPUT_DATA_SUCCESS = "FILTERED_INPUT_DATA_SUCCESS";
export const FILTERED_INPUT_DATA_FAILURE = "FILTERED_INPUT_DATA_FAILURE";
